import { SalaryIncreasePlaceholder } from "../components/SalaryIncreasePlaceholder";

export default function CrossBuReviewPage() {
  return (
    <SalaryIncreasePlaceholder
      title="Cross-BU Review"
      description="Review allocations across business units."
    />
  );
}
